import React from 'react';
//mui imports====
import { Box } from '@mui/system';
import useStyles from './styles';
import Typography from '@mui/material/Typography';
import Editor from '@monaco-editor/react';
//===============

const CodeEditor = ({
	label,
	language,
	value,
	height,
	editorOptions = {},
	containerStyles = {
		border: '1px solid rgba(0, 0, 0, 0.38)',
		margin: '.4rem',
		borderRadius: '4px'
	},
	updateCode
}) => {
	const classes = useStyles();

	return (
		<Box className={classes.inputConfigContainer} style={containerStyles}>
			<Typography className={classes.heading} fontWeight={600} variant="h6">
				{label}
			</Typography>
			<Editor
				height={height}
				defaultLanguage={language}
				value={value}
				onChange={updateCode}
				options={editorOptions}
				theme="vs-dark"
			/>
		</Box>
	);
};
export default React.memo(CodeEditor);
